var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-chevron-left")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }